import { sendOrderSuccess } from "../../service/orderService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { baseURL } from "api/apiService";
import Format from "utils/Format";

export function formatDate(isoString) {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Tháng tính từ 0
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

const printService = (metaData) => {
  // let ePos = new window.epson.ePOSDevice();
  const _user = localStorage.getItem("Apec_Account");
  console.log("metaData", metaData);
  const user = _user && JSON.parse(_user);
  const groupBy = (xs, key) => {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const wrapText = (text, maxLength) => {
    const words = text.split(" ");
    let result = [];
    let line = "";

    words.forEach((word) => {
      if (line.length + word.length + 1 <= maxLength) {
        line += (line.length > 0 ? " " : "") + word;
      } else {
        result.push(line);
        line = word;
      }
    });
    if (line.length > 0) {
      result.push(line);
    }
    return result;
  };

  const padRight = (text, length) => {
    return text?.padStart(length, " ");
  };

  const padLeft = (text, length) => {
    return text?.padEnd(length, " ");
  };

  const createRequestData = (items) => {
    var builder = new window.epson.ePOSBuilder();
    // Create a print document
    builder.addTextLang("en");
    builder.addTextSmooth(true);
    builder.addTextFont(builder.FONT_C);
    builder.addTextSize(2, 2);
    builder.addTextAlign(builder.ALIGN_CENTER);
    builder.addText(metaData?.hotelDetail.hotelName + "\n\n");
    builder.addTextAlign(builder.ALIGN_LEFT);
    builder.addTextFont(builder.FONT_A);
    builder.addTextSize(1, 1);
    builder.addText("Website: " + metaData?.hotelDetail.website + "\n");
    // builder.addTextSize(1, 1);
    builder.addText("Add: " + metaData?.hotelDetail.address + "\n");
    // builder.addTextSize(1, 1);
    builder.addText(
      "Tax code: " +
        metaData?.hotelDetail.taxCode +
        "\t" +
        "Hotline: " +
        metaData?.hotelDetail.phone +
        "\n"
    );
    // builder.addTextSize(1, 1);
    builder.addText("------------------------------------------------\n");
    builder.addTextAlign(builder.ALIGN_CENTER);
    builder.addTextSize(2, 2);
    builder.addTextFont(builder.FONT_C);
    builder.addText("HOÁ ĐƠN BÁN HÀNG\n\n");
    builder.addTextAlign(builder.ALIGN_LEFT);
    builder.addTextSize(1, 1);
    builder.addTextFont(builder.FONT_B);
    builder.addText(
      "Date: " +
        items[0].order_time +
        "\t" +
        "Địa điểm: " +
        items[0].rvcname +
        "\n"
    );
    builder.addTextSize(1, 1);
    builder.addText(
      "Order: " +
        items[0].order_no +
        "\t\t" +
        "Ngày in: " +
        formatDate(metaData?.printDate || "") +
        "\n\n"
    );
    builder.addTextStyle(false, false, true);
    builder.addText(
      "STT" +
        "   " +
        "Mặt hàng" +
        "\t   " +
        "DVT" +
        "     " +
        "SL" +
        "   " +
        "Đơn giá" +
        "     " +
        "Thành tiền" +
        "\n"
    );
    builder.addHLine(0, 200, builder.LINE_THIN_DOUBLE);
    builder.addTextFont(builder.FONT_A);
    builder.addTextStyle(false, false, false);
    let indexItem = 0;
    items.forEach((item, index) => {
      indexItem += 1;
      let wrappedText = wrapText(item.iname, 16);
      console.log("wrappedText ==", wrappedText);
      wrappedText.forEach((line, lineIndex) => {
        if (lineIndex === 0) {
          const length = 16 - line.length || 0;
          if (length > 0) {
            for (let i = 0; i < length; i++) {
              line += " ";
            }
          }
          builder.addText(indexItem + " " + line);
          builder.addText(
            padLeft(item.unit?.trim(), 4) +
              "  " +
              padLeft(`${item.quanitity || 0}`?.trim(), 3) +
              " " +
              padLeft(`${item.price ? item.price : ""}`?.trim(), 9) +
              (item.price ? item.price * item.quanitity : "") +
              "\n"
          );
        } else {
          builder.addText("   " + line + "\n");
        }
      });
      builder.addText("------------------------------------------------\n");
      isPrint = true;
    });
    builder.addTextSize(1, 1);
    builder.addTextFont(builder.FONT_A);
    builder.addTextStyle(false, false, true);
    builder.addTextPosition(0);
    builder.addText(
      "Tổng tiền: " +
        padRight(Format.formatMoneyNotD(metaData?.totalAmount) + " VNĐ", 35) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Giảm giá " +
        padLeft(
          metaData?.isDiscountPer === "Y" ? `(${metaData?.discount}%):` : ":",
          6
        ) +
        padRight(Format.formatMoneyNotD(metaData?.billDiscount) + " VNĐ", 30) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Thành tiền trước thuế: " +
        padRight(Format.formatMoneyNotD(metaData?.subTotal) + " VNĐ", 23) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Thuế & phí dịch vụ: " +
        padRight(
          Format.formatMoneyNotD(
            Number(metaData.tax) + Number(metaData.serviceCharge)
          ) + " VNĐ",
          26
        ) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Tổng tiền phải thanh toán: " +
        padRight(Format.formatMoneyNotD(metaData?.total) + " VNĐ", 19) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Tiền khách trả: " +
        padRight(Format.formatMoneyNotD(metaData?.amountPaid) + " VNĐ", 30) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Tiền trả lại: " +
        padRight(Format.formatMoneyNotD(metaData?.dueBack) + " VNĐ", 32) +
        "\n"
    );

    builder.addText(
      "Phương thức thanh toán: " +
        (metaData?.paymentMethod ? metaData?.paymentMethod : "") +
        "\n\n\n"
    );
    builder.addText("Cashier signature" + "\t\t" + "Guest signature \n\n\n");
    builder.addText("\n\n\n------------------------------------------------\n");
    builder.addTextStyle(false, false, false);
    builder.addTextAlign(builder.ALIGN_CENTER);
    builder.addText("(Giá đã bao gồm thuế GTGT và thuế dịch vụ)\n");
    builder.addText("Cảm ơn quý khách và hẹn gặp lại\n");
    builder.addCut(builder.CUT_FEED);

    return builder.toString();
  };
  var isPrint = false;
  let xml = "";
  if (metaData.itemsends && metaData.itemsends.length > 0) {
    let dataGroup = groupBy(metaData.itemsends, "ipaddress");
    let ipList = Object.keys(dataGroup);
    ipList.forEach((ip, index) => {
      isPrint = false;
      let items = dataGroup[ip];
      const itemIds = items.map((i) => i.item_id).join(",");
      //   xml =
      //     '<?xml version="1.0" encoding="utf-8"?><s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body>' +
      //     createRequestData(items) +
      //     "</s:Body></s:Envelope>";
      if (items.length > 0) {
        let request =
          '<?xml version="1.0" encoding="utf-8"?><s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body>' +
          createRequestData(items) +
          "</s:Body></s:Envelope>";
        const _request = request.replaceAll('"', "'");
        if (isPrint) {
          // epos.send(request);
          let isCall = false;
          if (isCall) return;
          axios
            .post(baseURL + "booking/api/print/send", {
              data: _request,
              ip: ip,
              //   ip: "10.10.40.252",
            })
            .then(function (response) {
              if (response.data) {
                switch (response.data) {
                  case "NO_CONNECTION":
                    toast.error(
                      `[${items[0].printeR_NAME}]` + "Máy in đang offline",
                      {
                        position: "top-right",
                        theme: "colored",
                      }
                    );
                    return;
                  case "SUCCESS":
                    toast.success(
                      `[${items[0].printeR_NAME}]` + "In order thành công !",
                      {
                        position: "top-right",
                        theme: "colored",
                      }
                    );
                    sendOrderSuccess({
                      orderNo: items[0].order_no,
                      itemIds: itemIds,
                    });
                    return;
                  case "FAILED":
                    toast.error(
                      `[${items[0].printeR_NAME}]` +
                        "In order thất bại. Vui lòng kiểm tra Wifi và thử lại !",
                      {
                        position: "top-right",
                        theme: "colored",
                      }
                    );
                    return;
                  case "EPTR_REC_EMPTY":
                    toast.error(`[${items[0].printeR_NAME}]` + "Hết giấy", {
                      position: "top-right",
                      theme: "colored",
                    });
                    return;
                  default:
                    return;
                }
              }
            })
            .catch(function (error) {
              toast.error(`[${items[0].printeR_NAME}]` + "In thất bại", {
                position: "top-right",
                theme: "colored",
              });
            });
          // var a = 'http://20.208.210.164/booking/api/print/send';
          //   toast.warn(`[${items[0].printeR_NAME}]` + "Đang in...", {
          //     position: "top-right",
          //     theme: "colored",
          //   });
          isCall = true;
        } else {
          // No Item to send
          // toast.error('Không có item để in', {
          //     position: 'top-right',
          //     theme: 'colored'
          // });
        }
      }
    });
    // return xml;
  }
};

export default printService;
